<template>
  <el-container
    direction="vertical"
    class="el-container--fullscreen"
    style="background-color: #00204d"
  >
    <base-center
      :span="8"
      :xs="18"
      :sm="14"
      :md="10"
      :lg="8"
    >
      <!-- xs < 769px <= sm < 1000 <= md < 1280 <= lg < 1920 <= xl-->
      <el-header
        :bordered="false"
        color="nav-primary">
        <template
          v-if="$slots.title"
        >
          <slot
            name="title"
          />
        </template>
        <span
          v-else
          :class="{
            'mb-32': true,
            'el-text': true,
            'el-text--display-medium': true,
            'el-text--ellipsis': true,
            'el-text--color-fixed-white': invert,
          }"
        >
          {{ title }}
        </span>
      </el-header>
      <base-card
        style="max-width: 672px; min-width: 432px"
        :alert="alert"
      >
        <base-card-item
          v-if="$slots.header"
          slot="header"
        >
          <slot
            name="header"
          />
        </base-card-item>
        <base-card-item>
          <slot/>
        </base-card-item>
      </base-card>
    </base-center>
  </el-container>
</template>

<script>
import BaseCenter from '../BaseCenter';
import BaseCard from '../BaseCard';
import BaseCardItem from '../BaseCardItem';

//xs < 769px <= sm < 1000 <= md < 1280 <= lg < 1920 <= xl

export default {
  name: 'CardLayout',
  components: {
    BaseCenter,
    BaseCard,
    BaseCardItem,
    // AppHeader,
  },
  props: {
    span: {
      type: [Number, Object],
      default: 24,
    },
    padding: {
      type: [Number, Object],
      default: 24,
    },
    title: {
      type: String,
      default: '',
    },
    invert: {
      type: Boolean,
      default: false,
    },
    alert: {
      type: Object,
    }
  },
};
</script>
